
//FG - FOOF - Change for certification - Created this class

export const HandleSafetyPlanElement = (safetyPlanElementInfo) => {
    return $.ajax({
        url: 'SafetyPlan/HandleSafetyPlanElement',
        data: safetyPlanElementInfo,
        //dataType: "json",
        processData: false,
        contentType: false,
        'accept-charset': 'utf-8',
        cache: false,
        type: 'POST'
      })
} 

export const getSafetyPlanElements = (locId) => {
    var x=  $.get('SafetyPlan/GetSafetyPlan?locId='+locId)
    return x;
  }


// WEBPACK FOOTER //
// ./src/pages/Compliance/safetyplan.service.js